import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Brown_Btn.css'

const Brown_Btn = (props) => {
    return (
        <button className="Brown_Btn" onClick={props?.onClick} type='button'>
            {props?.leftIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.leftIcon} className='left_icon' />
                </div>
            )}

            <p className='btn_text'>{props?.btn_name}</p>

            {props?.rightIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.rightIcon} className='right_icon' />
                </div>
            )}
        </button>
    )
}

export default Brown_Btn
